import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { cloneDeep, includes, isEmpty, map, size } from "lodash";

import Emitter from "../../utils/Emitter";

import { getCountryList, getHScodeSuggetions } from "../../actions/defaultDataAction";
import { getBuyerSupplierList } from "../../actions/memberAction";

import { default as ReactSelect, components } from "react-select";
import { WithContext as ReactTags } from "react-tag-input";

import DropDown from "../DropDown";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { showLoading } from "../../actions/loaderAction";
import defaultValues from "../../constant/defaultValues";
import ToolipsCustom from "../ToolipsCustom";
import SmallPopup from "../SmallPopup";
import { showSuccessMessage } from "../../utils/common";

const MemberFilter = (props) => {

    const { user } = useAuth();
    const { admin } = defaultValues;
    const [smallmodalShow, setSmallModalShow] = useState(false);

    const filterTypeOptions = [{
        label: 'Country',
        value: 'origin_country'
    }, {
        label: 'HS Code',
        value: 'hs_code'
    }, {
        label: 'Company Name',
        value: 'company_name'
    }, {
        label: 'Trading Country',
        value: 'trading_country'
    }];

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
            {/* <input type="checkbox" checked={isSelected} readOnly /> */}
            {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
            {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

        </div>

    );

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };

    const [filterTypeOptionVal, setFilterOptionVal] = useState(filterTypeOptions[0]);
    const [countryList, setCountryList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [tags, setTags] = useState([]);
    const [suggestions, setSuggetions] = useState([]);

    const [selected_members, setSelectedMembers] = useState([]);
    const [selected_target_country, setSelectedTargetCountry] = useState([]);
    const [selected_origin_country, setSelectedOriginCountry] = useState([]);
    const [isFilteredData, setFilterData] = useState(false);
    const [searchedTxt, setSearchedTxt] = useState(null);
    const initialFilterRef = useRef(true);
    const initialApplyFilterRef = useRef(false);
    const [memberOptLoader, setMemberOptLoader] = useState(false);
    const [showPreference, setShowPreference] = useState(false);

    const handleFilterTypeChange = (val) => {

        if (val) {
            if (val.value === "trading_country") {
                setSelectedMembers([]);
                setSelectedOriginCountry([]);
            }
            if (val.value === "company_name") {
                setSelectedTargetCountry([]);
                setSelectedOriginCountry([]);
            }
            if (val.value === "hs_code") {
                setSelectedMembers([]);
                setSelectedTargetCountry([]);
                setSelectedOriginCountry([]);
            }
            if (val.value === "origin_country") {
                setSelectedMembers([]);
                setSelectedTargetCountry([]);
            }
        }
        setFilterOptionVal(val);
    }

    const handleTagChange = (tagVal) => {
        // console.log("handleTagChange ======== ", tagVal);
        if (tagVal.value === undefined) {
            tagVal.label = tagVal.text;
        } else {
            tagVal.label = tagVal.value;
        }

        setTags((prevTags) => {
            return [...prevTags, tagVal]
        });
        setSearchedTxt(null);
    }

    const handleRemoveTag = (e, indx) => {
        // console.log("Index ============= ", indx);
        // setTags(tags.filter((_, i) => i !== indx));
        handleDelete(indx);
    }

    const handleDelete = (indx) => {
        setTags(tags.filter((_, i) => i !== indx));
    }

    const handleRemoveAllTags = () => {
        // console.log("handleRemoveAllTags is called .........");
        setTags([]);
        setSuggetions([]);
    }

    const handleInputChange = async (tag) => {
        // console.log("handleInputChange ======= ", tag);
        setSearchedTxt(tag);
        if (size(tag) > 3) {
            await getSuggetions(tag);
        }
        // setTag(tag);
    }

    const handleMemberChange = (val) => {
        // console.log("handleMemberChange >>> ", val);
        setSelectedMembers(val);
    }

    const getMembersInList = async (val) => {
        setMemberOptLoader(true);
        let data = await props.getBuyerSupplierList(0, 10, val);
        // console.log("Data ==== ", data);
        let x = data.data;
        let dataList = x.map((v) => {
            return {
                label: v.company_list_name,
                value: v.id,
                email: v.email
            }
        });
        setMemberList(dataList);
        setMemberOptLoader(false);
    }

    const handleMemberInputChange = (val, actionMeta) => {
        // console.log("handleMemberInputChange >>> ", val);
        const { prevInputValue } = actionMeta;
        if (val.length >= 3) {
            getMembersInList(val);
        } else if (val.length === 0 && (prevInputValue !== val)) {
            getMembersInList("");
        }
    }

    const handleTargetCountryChange = (val) => {
        setSelectedTargetCountry(val);
    }

    const handleOriginCountryChange = (val) => {
        setSelectedOriginCountry(val);
    }

    const filterMembers = () => {
        // on search check any filter available
        // check previous and new state are same 
        // console.log("SearchedTxt", searchedTxt);
        let user_id = 0;
        const { admin } = defaultValues;
        if (user) {
            user_id = user.id;
        }

        const filterObj = {};
        filterObj.filterBy = filterTypeOptionVal.value;
        let filterVal = map(tags, 'id');
        if (!isEmpty(searchedTxt)) {
            filterVal.push(searchedTxt);
        }

        filterObj.filter_val = filterVal;
        filterObj.selected_companies = map(selected_members, 'value');
        filterObj.selected_target_country = map(selected_target_country, 'value');
        filterObj.selected_origin_country = map(selected_origin_country, 'value');
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;

        setFilterData(true);

        Emitter.emit("SET_FILTER_MEMBERS", filterObj);
        // Emitter.emit("FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            setShowPreference(true);
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);


        // let filter_preferences = {};
        // filter_preferences.user_id = user_id;

        // let l_filterObj = cloneDeep(filterObj);
        // l_filterObj.txt_search = searchedTxt;
        // l_filterObj.filterTags = tags;
        // //filter_preferences.bsFilter = l_filterObj;
        // let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);
        // try {
        //     if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
        //         let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
        //         // console.log("parsed_old_filter_preferences ============= ", parsed_old_filter_preferences);
        //         // console.log("New filter preferences ============= ", l_filterObj);
        //         parsed_old_filter_preferences.bsFilter = l_filterObj;
        //         // console.log("Updated parsed_old_filter_preferences ============= ", parsed_old_filter_preferences);
        //         filter_preferences = parsed_old_filter_preferences;
        //         localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
        //     } else {
        //         filter_preferences.bsFilter = l_filterObj;
        //         localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
        //     }
        // } catch (e) {
        //     console.log("Exception --- ");
        // }

        // localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));

    }

    const resetFilter = () => {
        // console.log("resetFilter is called..");

        props.showLoading();
        const clearAllButton = document.getElementsByClassName("ReactTags__clearAll");
        if (clearAllButton.length > 0) {
            clearAllButton[0].click();
        } else {
            document.getElementsByClassName("search_input")[0].value = "";
        }

        const filterObj = {};
        filterObj.filterBy = filterTypeOptions[0].value;
        setFilterOptionVal(filterTypeOptions[0]);
        setSelectedMembers([]);
        setSelectedTargetCountry([]);
        setSelectedOriginCountry([]);
        setSearchedTxt(null);

        filterObj.filter_val = "";
        filterObj.selected_companies = [];
        filterObj.selected_target_country = [];
        filterObj.selected_origin_country = [];
        filterObj.table_search = "";
        filterObj.sortDirection = "DESC";
        filterObj.columnName = "id";
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;


        Emitter.emit("SET_FILTER_MEMBERS", filterObj);

        setTimeout(() => {
            Emitter.emit("FILTER_MEMBERS", filterObj);
        }, 1000);
        //need to check if filter is already reset then do not call again.

        // setFilterData(false);
        // if (isFilteredData) {
        //     Emitter.emit("FILTER_MEMBERS", filterObj);
        // } else {
        //     console.log("Reset is getting called again...");
        // }
        /* let user_id = 0;
        if (user) {
            user_id = user.id;
        }

        let filter_preferences = {};
        filter_preferences.bsFilter = {};

        /* localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences)); */


    }

    const fetchFilterSelection = async () => {

        const result = await Promise.allSettled([
            props.getCountryList(),
            // props.getServicesList(0, 10, ''),
            props.getBuyerSupplierList(0, 10, ''),
            // props.getHSCodeList()
            props.getHScodeSuggetions(0, 10, '')
        ]);

        result.forEach((res, indx) => {
            let dataList = [];
            let data = [];
            if (res.status === 'fulfilled') {
                if (includes([0], indx)) {
                    data = res.value;
                } else if (includes([1], indx)) {
                    data = res.value.data;
                }

                if (indx === 0) {
                    dataList = data.map((v) => {
                        return {
                            label: v.name,
                            value: v.id
                        }
                    });
                    setCountryList(dataList);
                }
                if (indx === 1) {
                    dataList = data.map((v) => {
                        return {
                            label: v.company_list_name,
                            value: v.id,
                            email: v.email
                        }
                    });
                    setMemberList(dataList);
                }

            } else {
                console.log("Something Went Wrong while fetching index ", indx, "!! ", res.reason);
            }
        });

    }

    const customFilter = (option, searchTxt) => {
        if (option.data.email.toLowerCase().includes(searchTxt.toLowerCase())) {
            return true;
        } else if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
            return true;
        } else {
            return false;
        }
    }

    const getSuggetions = async (searchVal) => {
        setSuggetions([]);
        await props.getHScodeSuggetions(0, 20, searchVal).then((data) => {
            let d = data;
            let suggetion_data = map(d, (v) => {
                return {
                    id: v.code,
                    text: `${v.description} (${v.code})`,
                    // text: v.code,
                    value: v.code
                };
            });
            setSuggetions(suggetion_data);
        })

    }

    const MoreSelectedBadge = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99,
        };

        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const MultiValue = ({ index, getValue, ...props }) => {
        const maxToShow = 2;
        const overflow = getValue()
            .slice(maxToShow)
            .map((x) => x.label);

        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <MoreSelectedBadge items={overflow} />
        ) : null;
    };

    const getFilterObj = () => {
        const filterObj = {};
        filterObj.filterBy = filterTypeOptionVal.value;
        let filterVal = map(tags, 'id');
        if (!isEmpty(searchedTxt)) {
            filterVal.push(searchedTxt);
        }

        filterObj.filter_val = filterVal;
        filterObj.selected_companies = map(selected_members, 'value');
        filterObj.selected_target_country = map(selected_target_country, 'value');
        filterObj.selected_origin_country = map(selected_origin_country, 'value');
        filterObj.limit = admin.LIMIT;
        filterObj.offset = admin.OFFSET;
        return filterObj;
    }

    const saveMemberPreferences = async (user_id = 0) => {
        if (user_id === 0) {
            if (user) {
                user_id = user.id;
            }
        }
        let u_id = 0;
        if (user) {
            u_id = user.id;
        }
        let filter_preferences = {};
        filter_preferences.user_id = u_id;
        let filterObj = await getFilterObj();
        if (!isEmpty(filterObj) && u_id > 0) {
            let l_filterObj = cloneDeep(filterObj);
            l_filterObj.txt_search = searchedTxt;
            l_filterObj.filterTags = tags;
            //filter_preferences.bsFilter = l_filterObj;
            let old_filter_preferences = localStorage.getItem("filter_preferences_" + u_id);
            try {
                if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                    let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                    // console.log("parsed_old_filter_preferences ============= ", parsed_old_filter_preferences);
                    // console.log("New filter preferences ============= ", l_filterObj);
                    parsed_old_filter_preferences.bsFilter = l_filterObj;
                    // console.log("Updated parsed_old_filter_preferences ============= ", parsed_old_filter_preferences);
                    filter_preferences = parsed_old_filter_preferences;
                    localStorage.setItem("filter_preferences_" + u_id, JSON.stringify(filter_preferences));
                } else {
                    filter_preferences.bsFilter = l_filterObj;
                    localStorage.setItem("filter_preferences_" + u_id, JSON.stringify(filter_preferences));
                }
            } catch (e) {
                console.log("Exception --- ", e);
            }
            setSmallModalShow(false);
            showSuccessMessage("Preferece saved Successfully");
            if (isEmpty(l_filterObj.filter_val) && isEmpty(l_filterObj.selected_companies) && isEmpty(l_filterObj.selected_target_country) && isEmpty(l_filterObj.filterTags) && isEmpty(l_filterObj.selected_origin_country)) {
                setShowPreference(false);
            } else {
                setShowPreference(true);
            }

            // localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
        } else if (isEmpty(filterObj) && u_id > 0) {
            let filter_preferences = {};
            filter_preferences.bsFilter = {};

            localStorage.setItem("filter_preferences_" + user_id, JSON.stringify(filter_preferences));
        }
    }

    const savePreferences = () => {
        let user_id = 0;
        if (user) {
            user_id = user.id;
        }
        if (user_id > 0) {
            let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);
            try {
                if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                    let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                    const { bsFilter } = parsed_old_filter_preferences;

                    if (!isEmpty(bsFilter)) {
                        setSmallModalShow(true);
                    } else {
                        saveMemberPreferences();
                    }
                } else {
                    saveMemberPreferences();
                }
            } catch (err) {
                console.log("Error >>> ", err);
            }
        } else {
            console.log("User does not Exists");
        }
    }

    /* const getPreferenceFromlocalStorage = () => {
        let user_id = 0;
        if (user) {
            user_id = user.id;
        }
        if (user_id > 0) {
            let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);
            try {
                if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                    let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                    const { bsFilter } = parsed_old_filter_preferences;

                    if (!isEmpty(bsFilter)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } catch (err) {
                console.log("Error >>> ", err);
            }
        }
    } */


    useEffect(() => {
        if (initialFilterRef.current === true) {
            fetchFilterSelection();
            initialFilterRef.current = false;
        }

    }, [initialFilterRef]);

    useEffect(() => {

        const fetchData = async () => {
            if (initialApplyFilterRef.current === false) {
                props.showLoading();
                if (size(countryList) > 0 && size(memberList) > 0) {

                    let user_id = 0;
                    if (user) {
                        user_id = user.id;
                    }
                    let old_filter_preferences = localStorage.getItem("filter_preferences_" + user_id);
                    try {
                        if (!isEmpty(old_filter_preferences) || old_filter_preferences) {
                            let parsed_old_filter_preferences = JSON.parse(old_filter_preferences);
                            const { bsFilter } = parsed_old_filter_preferences;

                            //console.log("bsFilter === ", bsFilter);
                            if (!isEmpty(bsFilter)) {
                                setShowPreference(false);
                                const filterObj = {};
                                filterObj.filterBy = bsFilter.filterBy;
                                // let filterVal = map(tags, 'id');
                                // if (!isEmpty(searchedTxt)) {
                                //     filterVal.push(searchedTxt);
                                // }

                                filterObj.filter_val = bsFilter.filter_val;
                                filterObj.selected_companies = bsFilter.selected_companies;
                                filterObj.selected_target_country = bsFilter.selected_target_country;
                                filterObj.selected_origin_country = bsFilter.selected_origin_country;

                                let t_countries = [];
                                let mList = [];
                                let o_countries = [];

                                bsFilter.selected_target_country.map((val) => {
                                    const selected_t_countries = countryList.find(
                                        (option) => option.value == val
                                    );
                                    t_countries.push(selected_t_countries);
                                });

                                setSelectedTargetCountry(t_countries);

                                bsFilter.selected_origin_country.map((val) => {
                                    const selected_o_countries = countryList.find(
                                        (option) => option.value == val
                                    );
                                    o_countries.push(selected_o_countries);
                                });
                                setSelectedOriginCountry(o_countries);


                                bsFilter.selected_companies.map((val) => {
                                    const selected_mem = memberList.find(
                                        (option) => option.value == val
                                    );
                                    console.log("selected_mem >>>>>>> ", selected_mem);
                                    if (selected_mem) {
                                        mList.push(selected_mem);
                                    }

                                });

                                if (isEmpty(mList) && !isEmpty(bsFilter.selected_companies)) {
                                    let resCompanies = await props.getBuyerSupplierList(0, 10, '', bsFilter.selected_companies);
                                    console.log("resCompanies >>>> ", resCompanies);
                                    if (!isEmpty(resCompanies)) {
                                        let dataList = resCompanies.data.map((v) => {
                                            return {
                                                label: v.company_list_name,
                                                value: v.id,
                                                email: v.email
                                            }
                                        })
                                        setMemberList(dataList);
                                        bsFilter.selected_companies.map((val) => {
                                            const selected_mem = dataList.find(
                                                (option) => option.value == val
                                            );

                                            if (selected_mem) {
                                                mList.push(selected_mem);
                                            }

                                        });
                                    }
                                }

                                setSelectedMembers(mList);

                                const selected_f_type = filterTypeOptions.find(
                                    (option) => option.value == bsFilter.filterBy
                                );

                                setFilterOptionVal(selected_f_type);

                                let selected_tgs = bsFilter.filterTags;

                                /*let searchedTxtObj = {
                                    className: "",
                                    id: bsFilter.txt_search,
                                    label: bsFilter.txt_search,
                                    text: bsFilter.txt_search
                                }
            
                                selected_tgs.push(searchedTxtObj); */

                                setTags(selected_tgs);
                                filterObj.limit = admin.LIMIT;
                                filterObj.offset = admin.OFFSET;

                                if (isEmpty(bsFilter.filterVal) && isEmpty(bsFilter.filterTags) && isEmpty(bsFilter.selected_companies) && isEmpty(bsFilter.selected_target_country)) {
                                    setShowPreference(false);
                                } else {
                                    setShowPreference(true);
                                }
                                //setSearchedTxt(bsFilter.txt_search);

                                Emitter.emit("SET_FILTER_MEMBERS", filterObj);
                                // Emitter.emit("FILTER_MEMBERS", filterObj);

                                setTimeout(() => {
                                    Emitter.emit("FILTER_MEMBERS", filterObj);
                                }, 1000);
                            } else {
                                resetFilter();
                                setShowPreference(false);
                            }

                        } else {
                            resetFilter();
                            setShowPreference(false);
                        }
                        initialApplyFilterRef.current = true;
                    } catch (e) {
                        console.log('Execption ..', e);
                    }
                }
            }
        }

        /* const fetchData1 = () => {
            if (initialApplyFilterRef.current === false) {
                props.showLoading();
                if (size(countryList) > 0 && size(memberList) > 0) {
                    resetFilter();
                    initialApplyFilterRef.current = true;
                }
                // props.hideLoading();
            }
        } */

        fetchData();
        // fetchData1();

    }, [user, countryList, memberList, initialApplyFilterRef]);

    /*useEffect(() => {
        let c = getPreferenceFromlocalStorage();
        if (c) {
            setShowPreference(true);
        } else {
            setShowPreference(false);
        }
    }, [isFilteredData]); */


    return (

        <div className="bg-white shadow rounded p-4 mb-4">
            <div className="row ">
                <div className="col-xl-2 col-lg-6 mt-2" >
                    <DropDown placeholder="Select.." options={filterTypeOptions} value={filterTypeOptionVal} onChange={handleFilterTypeChange} />
                </div>


                {filterTypeOptionVal.value === 'trading_country' && <div className="col-xl-3 col-lg-6 mt-2">

                    <ReactSelect
                        options={countryList}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                        onChange={handleTargetCountryChange}
                        value={selected_target_country}
                        // onInputChange={handleHsCodeInputChange}
                        removeSelected={false}
                        // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                        styles={customStyles}
                        placeholder="Select Country"
                        className="member-filter-container"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Country Found"}
                        id="target_country_dropdown"
                    // isOptionDisabled={() => hs_code.length >= 3}
                    />
                </div>}
                {/* {console.log("checkfilter_valur",filterTypeOptionVal.value)} */}


                {filterTypeOptionVal.value === 'origin_country' && <div className="col-xl-3 col-lg-6 mt-2">
                    <ReactSelect
                        options={countryList}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                        onChange={handleOriginCountryChange}
                        value={selected_origin_country}
                        // onInputChange={handleHsCodeInputChange}
                        removeSelected={false}
                        // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                        styles={customStyles}
                        placeholder="Select Country"
                        className="member-filter-container"
                        classNamePrefix="member-filter-select"
                        noOptionsMessage={() => "No Country Found"}
                        id="origin_country_dropdown"
                    // isOptionDisabled={() => hs_code.length >= 3}
                    />
                </div>}

                {filterTypeOptionVal && filterTypeOptionVal.value === "company_name" &&
                    <div className={`${filterTypeOptionVal && filterTypeOptionVal.value === "company_name" ? "col-xl-3 col-lg-6 mt-2  " : "col-xl-4 col-lg-6 mt-2"}`}>

                        <div className="d-flex align-items-center w-100">
                            <ReactSelect
                                options={memberList}
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                                onChange={handleMemberChange}
                                value={selected_members}
                                onInputChange={handleMemberInputChange}
                                removeSelected={false}
                                // isDisabled={isSuperAdmin ? false : (props.isDisable || props.disableProfile)}
                                styles={customStyles}
                                placeholder="Select Company"
                                className="member-filter-container w-100"
                                classNamePrefix="member-filter-select"
                                noOptionsMessage={() => "No Company Found"}
                                filterOption={customFilter}
                                id="member_list_dropdown"
                                isLoading={memberOptLoader}
                            // isOptionDisabled={() => hs_code.length >= 3}
                            />
                            <ToolipsCustom
                                title={"?"}
                                subtitle={"Search Using Company Name, Email Id or Member Unique Number "}
                                classNameChild={"tooltip-responsive"}
                            ></ToolipsCustom>
                        </div>

                    </div>}

                <div className={` ${filterTypeOptionVal && filterTypeOptionVal.value === "hs_code" ? "col-xl-6 mt-2" : ""} col-xl-3 col-lg-6 mt-2`} >
                    <ReactTags
                        tags={tags}
                        name="search_txt"
                        inputFieldPosition="top"
                        suggestions={suggestions}
                        placeholder="Search Keywords"
                        handleDelete={handleDelete}
                        handleAddition={handleTagChange}
                        // handleDrag={handleDrag}
                        // handleTagClick={handleTagClick}
                        // onTagUpdate={onTagUpdate}
                        // removeComponent={RemoveComponent}
                        handleInputChange={handleInputChange}
                        editable={false}
                        clearAll
                        onClearAll={handleRemoveAllTags}
                        // maxTags={5}
                        allowAdditionFromPaste
                        classNames={{ tagInputField: "form-control form-size w-100 search_input" }}
                        inputProps={{
                            autoComplete: "off"
                        }}
                    />
                </div>

                <div className="col-xl-4 col-lg-6 d-flex filter-search-btn mt-2" >
                    <div className="d-flex align-items-center">

                        <ToolipsCustom
                            title={<>
                                <ButtonAdminpanel type="button" onClick={filterMembers} className="btn-regi">  <i className="fa-solid fa-magnifying-glass text-white"></i>  </ButtonAdminpanel>
                            </>}
                            subtitle={"Search Preference"}
                            classNameChild={"responsive-tooltip"}
                        >


                        </ToolipsCustom>

                        <ToolipsCustom
                            title={<>
                                <button type="button" className=" btn filter-reset-btn" onClick={resetFilter}>
                                    <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>

                                </button></>}
                            subtitle={"Reset Your Preference"}
                            classNameChild={"responsive-tooltip"} >



                        </ToolipsCustom>
                        {
                            showPreference && <ButtonAdminpanel type="button" className="ms-2" onClick={savePreferences}>Save Preferences</ButtonAdminpanel>
                        }
                    </div>
                </div>

            </div>

            <div className="row pt-2 ">
                <div className="col-md-12 col-xl-12 ">
                    <div className="selected-custom-tags p-0">
                        {tags.map((val, indx) => {
                            return (
                                <>
                                    <div key={`tag_${indx}`} className="selected-custom-tags-child">

                                        <ToolipsCustom className={"selected-custom-tag-text hscode-tooltip"} classNameChild={"hscode-tooltip-msg member"} title={val.label} subtitle={`${val.text}`}>
                                        </ToolipsCustom>

                                        <div className="selected-custom-tag-button">
                                            <i className="fa-solid fa-x mx-1" key={`remove_${indx}`} onClick={(e) => handleRemoveTag(e, indx)}></i>
                                        </div>

                                    </div>
                                </>
                            )
                        })}
                    </div>
                </div>
            </div>

            <SmallPopup
                title="Alert"
                smallmodalShow={smallmodalShow}
                setSmallModalShow={setSmallModalShow}
                onSubmit={saveMemberPreferences}
                closeButtonLabel="Cancel"
                okButtonLabel="Save Prefrences"
                className="btn-assign"
            >
                Are you sure You want to save Prefrences?
                <p><b>Note:</b> <small> The previously saved preferences will be discarded. </small></p>

            </SmallPopup>
        </div>


    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCountryList: () => dispatch(getCountryList()),
        getBuyerSupplierList: (offset, limit, searchtxt, selected_ids) => dispatch(getBuyerSupplierList(offset, limit, searchtxt, selected_ids)),
        getHScodeSuggetions: (offset, limit, searchTxt) => dispatch(getHScodeSuggetions(offset, limit, searchTxt)),
        showLoading: () => dispatch(showLoading())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(MemberFilter));

